import { Grid, Link, styled } from "@mui/material";
import { Apps, ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import React, { FC } from "react";
import { Blog } from "../../../interfaces";

const PreviousAndNext: FC<Props> = ({ blogs, currentIndex, uri }) => {
  const strings = {
    previous: "Previous",
    next: "Next",
  };

  return (
    <StyledSection>
      <hr />
      <Grid container spacing={5}>
        <Grid item xs={12} md={5}>
          {blogs[currentIndex - 1] && (
            <StyledLink
              style={{ textDecoration: "none", justifyContent: "flex-start" }}
              href={`${uri}/${blogs[currentIndex - 1].postId}`}
            >
              <ArrowBackIos fontSize="large" className="icon" />
              <div>
                <p className="subtitle">{strings.previous}</p>
                <h2 className="title">{blogs[currentIndex - 1].postTitle}</h2>
              </div>
            </StyledLink>
          )}
        </Grid>

        <Grid item md={2}>
          <StyledLink style={{ justifyContent: "center" }} href={uri}>
            <Apps fontSize="large" className="icon" />
          </StyledLink>
        </Grid>

        <Grid item xs={12} md={5}>
          {blogs[currentIndex + 1] && (
            <StyledLink
              style={{
                textDecoration: "none",
                justifyContent: "space-between",
              }}
              href={`${uri}/${blogs[currentIndex + 1].postId}`}
            >
              <div>
                <p className="subtitle">{strings.next}</p>
                <h2 className="title">{blogs[currentIndex + 1].postTitle}</h2>
              </div>
              <ArrowForwardIos fontSize="large" className="icon" />
            </StyledLink>
          )}
        </Grid>
      </Grid>
      <hr />
    </StyledSection>
  );
};

interface Props {
  blogs: Blog[];
  currentIndex: number;
  uri: string;
}

const StyledSection = styled("section")(({ theme }) => ({
  margin: "2rem 0",
}));

const StyledLink = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "25px",
  height: "100%",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
  "& .icon": {
    color: "#eeeeee",
    "&:hover": {
      color: "#aaaaaa",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  "& .title": {
    fontSize: "16px",
    color: theme.palette.primary.dark,
    marginTop: 0,
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  "& .subtitle": {
    textTransform: "uppercase",
    marginBottom: "5px",
    color: "#949599!important",
    fontSize: "14px!important",
  },
}));


export default PreviousAndNext;
